import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "patient-details" }
const _hoisted_2 = { class: "profile-status" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "pic" }
const _hoisted_5 = {
  key: 1,
  class: "no-pic fas fa-user"
}
const _hoisted_6 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HHPatientMain = _resolveComponent("HHPatientMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.selectedPatientDetails.Branch), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.patientDetails.PhotoUrl)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "uploaded-pic",
              ref: "userPicElement",
              style: _normalizeStyle({ backgroundImage: `url(${_ctx.patientDetails.PhotoUrl})` })
            }, null, 4 /* STYLE */))
          : (_openBlock(), _createElementBlock("i", _hoisted_5))
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(String(_ctx.statusEnum.getDescriptionUsingValue(_ctx.selectedPatientDetails.Status)).toLocaleUpperCase()), 1 /* TEXT */)
    ]),
    _createVNode(_component_HHPatientMain, {
      selectedPatientDetails: _ctx.selectedPatientDetails,
      patientRiskDetails: _ctx.patientRiskDetails,
      patientDetails: _ctx.patientDetails
    }, null, 8 /* PROPS */, ["selectedPatientDetails", "patientRiskDetails", "patientDetails"])
  ]))
}